<template>
  <div class="mod-extra-book clearfix">
    <div class="container clearfix">
      <div class="mod-extra-passennger">
        <a-tabs
          class="Passenger-wrapper"
          :defaultActiveKey="0"
          type="card"
          v-model="current.passengerIndex"
          @change="selectPassenger"
        >
          <a-tab-pane
            v-for="(passenger,idx) in arrPassenger"
            :key="idx"
          >
            <span slot="tab">{{ current.passengerIndex === idx ? ('旅客'+(idx+1)+' '+passenger.passengerName+' 证件号:' +passenger.certNo):passenger.passengerName}}</span>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="w-1300 clearfix">
        <div class="flights-left">
          <flight-alone
            :itinerarys="itinerarys"
            :current="current"
            @select="selectItinerarys"
          />
        </div>
        <div class="products-right">
          <products
            :segment="itinerarys[current.segmentIndex]"
            :current="current"
            :isSelfAirline="isSelfAirline"
            :productDesList="productDesList"
            :productIntDesList="productIntDesList"
            :insuranceDesList="insuranceDesList"
            :seatAgreeMentList="seatAgreeMentList"
            :noProductTipsConfig="noProductTipsConfig"
            :productBase="productBase"
            @select="onSelectChange"
            @contactChange="contactValueChange"
            @couponchange="couponChange"
          />
        </div>
      </div>
      <div class="foot">
        <a-button
          class="btn"
          type="primary"
          @click="back"
        >上一步</a-button>
        <a-button
          class="btn"
          type="primary"
          @click="placeOrderCheck"
          v-if="!nextLoading"
        >下一步</a-button>
        <a-button
          v-else
          type="dashed"
          class="btn"
        >{{loadingText}}</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchPurchased, fetchOffer, placeOrder, checkExtraPlace } from '@/apis/extra'
import flightAlone from './components/flight-alone.vue'
import products from '../extra-book/components/products.vue'
import { message } from 'ant-design-vue'
import Storage from '@/assets/js/storage'
import { each, get, cloneDeep, isEmpty, omitBy, isUndefined, isNull, isBoolean } from 'lodash'
import { passengerTypeMap } from '@/dicts/common'
import Observer from '@/assets/js/observer'
import { productTypeList, productConfig } from '@/pages/extra-book/data/config'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}

const productTypeMap = {
  LUGGAGE: 'luggage',
  MEAL: 'meal',
  VIPHALL: 'viphall',
  ITINERARY: 'itinerary'
}

const productTypeConvertMap = {
  luggage: 'LUGGAGE',
  meal: 'MEAL',
  insurance: 'INSURANCE',
  lugInsurance: 'INSURANCE',
  itinerary: 'ITINERARY',
  seat: 'SEAT'
}

const productType = Object.keys(productTypeMap)
export default {
  data () {
    return {
      userInfo: {},
      current: {
        segmentIndex: 0,
        passengerIndex: 0
      },
      arrPassenger: [],
      itinerarys: [],
      nextLoading: false,
      loadingText: '正在提交...',
      seatAgreeMentList: [],
      insuranceDesList: [],
      productDesList: [],
      ifInternational: false,
      noProductTipsConfig: [],
      productIntDesList: [],
      itineraryProduct: {}
    }
  },
  async created () {
    await this.getCmsData()

    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      this.userInfo = {
        phone: userInfo.phone,
        loginId: userInfo.loginName
      }
    }

    const passengerStr = Storage.getItem('extraItinerarys')
    if (passengerStr) {
      const passenger = JSON.parse(passengerStr)
      const passengerTemp = {
        certificateNo: passenger.certNo,
        passengerName: passenger.passengerName
      }
      this.arrPassenger = [passenger]
      this.userInfo['phone'] = passenger.phone

      // 转换成跟随票辅营一样的数据结构
      const itinerarys = passenger.itinerarys.map(segment => {
        segment.passengers = [
          {
            ...passengerTemp,
            passengerName: segment.passengerName,
            passengerType: segment.passengerType
          }
        ]

        return segment
      })
      this.itinerarys = itinerarys
      await itinerarys.forEach((item, i) => {
        if (item.ifInternational) {
          this.ifInternational = true
        }
        productType.forEach(type => {
          // NOTE: 国际票不获取行程单
          // if (this.ifInternational && type === 'ITINERARY') {
          //   return
          // }
          this.fetchProducts(i, type)
        })
        // 获取已购
        this.fetchBought(i)
      })
      // 查询权益更改为从订单详情获取并初始化
      this.updateBenefit()
    }

    const isAgent = [1, 2].includes(mainSettings.user?.get()?.userType)
    this.payUrl = !isAgent ? '/extraalone/v2/pay' : '/extraalone/pay'
  },
  computed: {
    isSelfAirline () {
      const { itinerarys } = this
      return Array.isArray(itinerarys) && get(itinerarys[0], 'airline') === mainSettings.airline
    },
    // 辅营产品配置，组装 cms 配置和本地配置文件的结果
    productBase () {
      const { productDesList } = this
      const productBase = {}
      productTypeList.forEach(type => {
        let productBaseByCms = productDesList.find(item => { return item.key === type })
        productBaseByCms = omitBy(productBaseByCms, (v) => isUndefined(v) || isNull(v) || v === '')
        productBase[type] = productBaseByCms ? { ...productConfig[type], ...productBaseByCms } : productConfig[type]
      })
      return productBase
    }
  },
  methods: {
    async getCmsData () {
      const { ifInternational } = this
      const pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) ?? {}
      this.seatAgreeMentList = get(pageCmsData, 'extra-seat-list.list') ?? []
      this.insuranceDesList = get(pageCmsData, 'extra-insurance-desc.infomation') ?? []
      this.productDesList = get(pageCmsData, !ifInternational ? 'extra-product-desc.infomation' : 'extra-product-desc-int.infomation') ?? []
      this.productIntDesList = get(pageCmsData, 'extra-product-desc-int.infomation') ?? []
      this.noProductTipsConfig = get(pageCmsData, 'noProductTips.list') ?? []
    },
    selectPassenger (idx) {
      this.current = {
        passengerIndex: idx,
        segmentIndex: 0
      }
    },
    selectItinerarys (idx) {
      this.current.segmentIndex = idx
    },
    // 辅营产品选择
    onSelectChange (type, value) {
      const { segmentIndex, passengerIndex } = this.current
      const itinerarys = this.itinerarys
      const passengers = itinerarys[segmentIndex].passengers || []
      const select = passengers[passengerIndex].select || {}
      select[type] = value
      passengers.splice(passengerIndex, 1, {
        ...passengers[passengerIndex],
        select
      })
      this.itinerarys.splice(segmentIndex, 1, {
        ...itinerarys[segmentIndex],
        passengers
      })
    },
    // 行程单数据变化
    contactValueChange (cartValue, contact) {
      this.contact = contact
      this.itineraryProduct = cartValue
    },
    // 优惠券选择
    couponChange (coupons, type, add) {
      const { segmentIndex, passengerIndex } = this.current

      if (coupons) {
        const itinerarys = this.itinerarys
        const passengers = itinerarys[segmentIndex].passengers || []
        const select = passengers[passengerIndex].select || {}
        select[type][0].coupons = add ? coupons : {}
        passengers.splice(passengerIndex, 1, {
          ...passengers[passengerIndex],
          select
        })
        this.itinerarys.splice(segmentIndex, 1, {
          ...itinerarys[segmentIndex],
          passengers
        })
      }
    },
    back () {
      window.history.go(-1)
    },
    async fetchProducts (segIndex, productType) {
      const { itinerarys = [], productBase } = this
      const seg = itinerarys[segIndex]
      const params = {
        segs: [{
          depCode: seg.depCode,
          arrCode: seg.arrCode,
          ticketNo: seg.ticketNo,
          passengerName: seg.passengerName
        }],
        productType: productType
      }

      // CMS 控制是否查询指定类型的产品
      const productSwitch = productBase?.[productTypeMap[productType]]?.aloneSwitchStatus
      if (isBoolean(productSwitch) && !productSwitch) {
        return false
      }

      try {
        const result = await fetchOffer(params)
        // 原node层的处理数据
        const products = result?.[0]?.products
        const finalResult = []
        if (products) {
          const productPrices = products.map(product => {
            const extraParams = {}
            if (mainSettings.airline === 'JD' && product.productType === 'MEAL') {
              extraParams.productNum = 0
              extraParams.isComplex = true
            }
            return { services: [{ ...product, ...extraParams, 'attach': product.image }] }
          })
          finalResult.push({
            detail: {
              productPrices
            }
          })
        }
        this.$set(this.itinerarys[segIndex], productTypeMap[productType], finalResult)
      } catch (e) {
        this.$message.error(e.message || '网络异常，请稍后再试！')
      }
    },
    fetchBought (segIndex) {
      const { itinerarys } = this
      const seg = itinerarys[segIndex]
      const arr = seg.ticketNo.split('-')
      const ticketNo = arr[1] || arr[0]
      const params = {
        issCode: '',
        arrCode: seg.arrCode,
        depCode: seg.depCode,
        flightNo: seg.flightNo,
        passengerName: seg.passengerName,
        ticketNo: ticketNo
      }

      fetchPurchased(params).then((res) => {
        const bought = {}
        const result = res
        for (var key in res) {
          if (Array.isArray(res[key])) {
            result[key] = res[key].map((product) => {
              return product.productName
            })
          }
          bought[key] = result[key].join(',')
        }
        this.$set(this.itinerarys[segIndex], 'bought', bought)
      }).catch((error) => {
        this.$message.error(error.message || '已购辅营查询失败，请稍候重试。')
      })
    },
    // 设置航班权益
    updateBenefit () {
      const { itinerarys } = this
      const freeBef = {
        luggage: '0',
        meal: '无'
      }
      each(itinerarys, (seg = {}) => {
        const _freeBef = cloneDeep(freeBef)
        if (!seg.benefit) {
          this.$set(seg, 'benefits', null)
          return
        }
        seg.benefit?.benefits?.[0]?.benefitDetails.forEach(bef => {
          const mealCodeList = ['MEAL', 'FOOD_IN_THE_AIR']
          if (mealCodeList.indexOf(bef.code) >= 0) {
            _freeBef.meal = bef.name
          }
        })
        seg.benefit?.benefits?.[0]?.languageBenefitDetails.forEach(bef => {
          if (bef.passengerType === seg.passengers[0].passengerType || bef.passengerType === passengerTypeMap[seg.passengers[0].passengerType]) {
            // const isPiece = bef.checkinBenefit?.code === 'BAGGAGE-PIECE'
            // _freeBef.luggage = !isPiece ? ((bef.checkinBenefit?.name?.replace(/[^0-9]+/g, '') || 0) + 'KG') : ((bef.checkinBenefit?.data || 0) + '件')
            _freeBef.luggage = bef.checkinBenefit?.data
          }
        })
        this.$set(seg, 'benefits', _freeBef)
      })
    },
    async placeOrderCheck () {
      this.nextLoading = true
      this.loadingText = '正在提交...'
      const { itinerarys, contact, itineraryProduct, ifInternational } = this

      // 添加行程单
      if (contact && contact.invoice === 'Y') {
        let bShow = false

        for (const key in contact) {
          if (contact.hasOwnProperty(key) && contact[key] === '') {
            bShow = true
            break
          }
        }
        if (bShow) {
          this.nextLoading = false
          message.error('请完善行程单信息')
          return
        }
      }

      const paxSegs = []
      itinerarys.forEach(seg => {
        const offerItemIdNums = []
        const passengerNums = []
        const coupons = []

        seg.passengers.forEach(psg => {
          Object.keys(psg.select || {}).forEach(key => {
            const arr = psg.select[key]
            Array.isArray(arr) && arr.forEach(product => {
              offerItemIdNums.push(product.offerItemId)
              passengerNums.push({
                offerItemId: product.offerItemId,
                passengerNum: product.productNum,
                offerItemType: productTypeConvertMap[key]
              })

              const couponValue = product.coupons

              if (couponValue && !isEmpty(couponValue)) {
                coupons.push({
                  couponNo: couponValue.couponNumber,
                  couponType: couponValue.couponType,
                  offerItemId: product.offerItemId
                })
              }
            })
          })
        })

        // 行程单
        if (contact && contact.invoice === 'Y') {
          let product = {}
          if (!ifInternational) {
            product = seg.itinerary[0].detail.productPrices[0].services[0] || { offerItemId: '' }
          } else {
            product = !isEmpty(itineraryProduct) ? itineraryProduct.detail : { offerItemId: '' }
          }
          offerItemIdNums.push(product.offerItemId)
        }

        if (offerItemIdNums.length) {
          paxSegs.push({
            depCode: seg.depCode,
            itinerary: contact || {},
            coupons: coupons,
            offerItemIdNums,
            passengerNums,
            passengerName: seg.passengerName,
            ticketNo: seg.ticketNo
          })
        }
      })

      if (paxSegs.length === 0) {
        this.$message.error('请选择需要购买的产品')
        this.nextLoading = false
        return
      }
      const observer = new Observer()

      // NOTE: JD - 复合餐食提示，超过3份需要提示用户
      if (mainSettings.airline === 'JD') {
        let mealSum = 0
        paxSegs?.forEach(paxSeg => {
          const { passengerNums = [] } = paxSeg
            passengerNums?.forEach(passengerNum => {
              if (passengerNum.offerItemType === 'MEAL') {
                mealSum += passengerNum.passengerNum
              }
            })
        })
        if (mealSum >= 3) {
          observer.add(() => {
            return new Promise((resolve, reject) => {
              this.$confirm({
                title: '温馨提示',
                content: `您好，您当前下单的餐食数量共计${mealSum}份，请确认您预定的餐食数量及支付金额。如为操作失误，请修改后下单。谢谢！`,
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                  resolve()
                },
                onCancel: () => {
                  this.nextLoading = false
                  reject(new Error('cancel'))
                }
              })
            })
          })
        }
      }

      // NOTE: 接口校验单独辅营是否可以下单及返回提示
      const { userInfo } = this
      const params = {
        loginId: userInfo.loginId,
        phone: userInfo.phone,
        paxSegs
      }
      if (mainSettings.airline === 'JD') {
        const checkResult = await checkExtraPlace(params)
        if (checkResult.dialogFlag) {
          observer.add(() => {
            return new Promise((resolve, reject) => {
              if (checkResult.canPlace) {
                this.$confirm({
                  title: '温馨提示',
                  content: `${checkResult.dialogText}`,
                  okText: '确定',
                  cancelText: '取消',
                  onOk: () => {
                    resolve()
                  },
                  onCancel: () => {
                    this.nextLoading = false
                    reject(new Error('cancel'))
                  }
                })
              } else {
                this.$error({
                  title: '温馨提示',
                  content: `${checkResult.dialogText}`,
                  okText: '确认',
                  onOk: () => {
                    this.nextLoading = false
                    reject(new Error('cancel'))
                  }
                })
              }
            })
          })
        }
      }

      observer.complete = () => {
        this.placeOrder(params)
      }

      observer.start()
    },
    placeOrder (params) {
      placeOrder(params).then((res) => {
        const { payUrl } = this
        this.nextLoading = true
        this.loadingText = '正在跳转...'
        this.$router.push({ path: payUrl, query: { orderNo: res } })
      }).catch((error) => {
        this.nextLoading = false
        this.loadingText = '正在提交...'
        this.$message.error(error.message || '权益查询失败，请稍候重试。')
      })
    }
  },
  components: {
    flightAlone,
    products
  }
}
</script>
